// SPA mode: the whole app is client-rendered (existing code expects browser APIs)
export const ssr = false
